module.exports = __webpack_public_path__ + "static/img/Frame_04.38305d1b.svg";